export default {
    home: "/",
}